var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18007",
    "data-name": "Grupo 18007",
    transform: "translate(-28 -239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18006",
    "data-name": "Grupo 18006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18005",
    "data-name": "Grupo 18005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17703",
    "data-name": "Grupo 17703",
    transform: "translate(0 105)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_84807",
    "data-name": "Rect\\xE1ngulo 84807",
    width: 32,
    height: 32,
    rx: 5,
    transform: "translate(28 134)",
    fill: "#d1f0ef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-video",
    "data-name": "Icon feather-video",
    transform: "translate(34.5 242.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_106879",
    "data-name": "Trazado 106879",
    d: "M29.312,10.5,24,14.294l5.312,3.794Z",
    transform: "translate(-11.117 -1.482)",
    fill: "none",
    stroke: "#1aa8a2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_106880",
    "data-name": "Trazado 106880",
    d: "M3.018,7.5h8.348a1.518,1.518,0,0,1,1.518,1.518v7.589a1.518,1.518,0,0,1-1.518,1.518H3.018A1.518,1.518,0,0,1,1.5,16.607V9.018A1.518,1.518,0,0,1,3.018,7.5Z",
    fill: "none",
    stroke: "#1aa8a2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.36297c12d041ebb877b5cb856f533e36.svg";
export { ForwardRef as ReactComponent };